const selectors$17 = {
  dataHeaderSection: '[data-header-section]',
  skipLink: '.skip-link',
  navigation: '.navigation',
  navAnimateElements: '.navigation__entrance-animation',
  cartBubble: '.site-header__cart-bubble',
  siteHeader: '.site-header',
  siteHeaderWrapper: '.site-header__wrapper',
  siteHeaderLogo: '.site-header__logo',
  siteHeaderCart: '.site-header__cart',
  siteNavigation: '[data-site-navigation]',
  navigationButton: '[data-navigation-button]',
  navigationExpandSublinks: '.navigation__expand-sublinks',
  navigationExpandChildSublinks: '.navigation__expand-sublinks--third-level',
  navigationSublinksContainer: '.navigation__sublinks-container',
  navigationSublink: '.navigation__sublink',
  navigationSublinks: '.navigation__sublinks',
  navigationChildSublinks: '.navigation__sublinks--third-level',
  navigationHasSublinks: '.navigation__has-sublinks',
  announcementBar: '.announcement-bar',
  announcementBarClose: '.announcement-bar__close',
  contentForLayout: '.content-for-layout'
};

const classes$16 = {
  themeEditor: 'theme-editor',
  headerFixed: 'site-header--fixed',
  headerHomepage: 'site-header--homepage',
  headerTransparent: 'site-header--transparent',
  cartBubbleVisible: 'site-header__cart-bubble--visible',
  bubblePulse: 'bubble-pulse',
  drawerActive: 'drawer--active',
  navigationExpandChildSublinks: 'navigation__expand-sublinks--third-level',
  navigationOpen: 'navigation-open',
  navigationOpenEditor: 'navigation-open--editor',
  navigationTransitioning: 'navigation--is-transitioning',
  navigationHasSublinksCollapsed: 'navigation__has-sublinks--collapsed',
  navigationEntranceActive: 'navigation__entrance-animation--active',
  siteHeaderWrapperTransitioning: 'site-header__wrapper--transitioning',
  announcementBarVisible: 'announcement-bar--visible'
};

class HeaderSection extends HTMLElement {
  scrollHandler = true;
  blockEditorEvents = false;
  navigationManuallyToggled = false;

  constructor() {
    super();
    this.container = document.querySelector(selectors$17.dataHeaderSection);
    this.$container = $(this.container);
    this.$siteHeader = $(selectors$17.siteHeader);
    this.$siteHeaderWrapper = $(selectors$17.siteHeaderWrapper);

    this.scrollTop = 0;
    this.isFixed = false;
    this.headerHeight = 0;
    this.promiseChain = $.Deferred().resolve();
    this._updateHeaderTransparency();

    // Initially disable tabbing through site navigation
    this.disableTabbingOfChildren(selectors$17.navigation);

    $(selectors$17.navigationButton)
        .one('click', this._toggleNavigationDisplay.bind(this))
        .one('click', this._setSublinksMaxHeight.bind(this));

    $(selectors$17.navigationExpandSublinks, this.$container).on(
        'click',
        this._toggleNavigationSublinks.bind(this)
    );

    $(selectors$17.announcementBarClose, this.$container).on(
        'click',
        this._closeAnnouncementBar.bind(this)
    );
    this._setupAnnouncementBar();
  }

  _setupAnnouncementBar() {
    var $announcementBar = $(selectors$17.announcementBar, this.$container);

    if (!$announcementBar.length) return;

    if (
        this.utils.isSessionStorageSupported() &&
        sessionStorage.getItem('announcement-bar-hidden')
    ) {
      requestAnimationFrame(
        function() {
          $announcementBar.removeClass(classes$16.announcementBarVisible);
        }.bind(this)
      );
    }
  }

  _closeAnnouncementBar(evt) {

    evt.preventDefault();

    if (Shopify.designMode) return;

    var $announcementBar = $(selectors$17.announcementBar);

    requestAnimationFrame(function() {

      this.$siteHeaderWrapper
                  .addClass(classes$16.siteHeaderWrapperTransitioning);
      
      requestAnimationFrame(function() {
        this.$siteHeaderWrapper.css(
            'margin-top',
            '-' + $announcementBar.outerHeight() + 'px'
        );
    
        $(selectors$17.announcementBarClose).attr('aria-expanded', false);
    
        if (this.utils.isSessionStorageSupported()) {
          sessionStorage.setItem('announcement-bar-hidden', true);
        }
    
        this.utils.promiseTransitionEnd(this.$siteHeaderWrapper).then(
            function() {
              $announcementBar.remove();
    
              this.$siteHeaderWrapper
                  .removeClass(classes$16.siteHeaderWrapperTransitioning)
                  .css('margin-top', '');
            }.bind(this)
        );
      }.bind(this));
    }.bind(this));
  }

  disableTabbingOfChildren(containers) {
    $(containers).each(function(index, container) {
      $(
          'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]',
          container
      ).attr('tabindex', '-1');
    });
  }
  _updateHeaderTransparency() {
    if ($('html').hasClass('is-ios') && Shopify.designMode) return;

    this.$siteHeader.removeClass(classes$16.headerTransparent);

    // Only continue if we're on the homepage and transparent header setting is enabled.
    if (!this.$siteHeader.data('transparent-header')) return;


    this.$siteHeader.addClass(classes$16.headerTransparent);
  }

  _toggleHeaderPosition() {
    // Check if toggle is disabled by other settings
    if (!this.scrollHandler || this.headerAnimating) return;

    var scrollTop = $(document).scrollTop();

    this.headerHeight = this.$container.outerHeight();

    // Check which header transformation needs to happen. Also check if a toggle
    // even needs to happen, i.e. if you're scrolling up and the header is
    // already displayed, why call slideOut again?
    // Debounce any style changes to the next frame using requestAnimationFrame
    if (scrollTop <= 0) {
      if (!this.headerAnimating) {
        //requestAnimationFrame(this._promiseHeaderReset.bind(this));
      }
    } else if (
        scrollTop < this.scrollTop &&
        scrollTop > 0 &&
        !this.isFixed &&
        !this.isAnimating
    ) {
      requestAnimationFrame(this._promiseHeaderSlideIn.bind(this));
    } else if (
        scrollTop > this.scrollTop &&
        scrollTop > this.headerHeight &&
        this.isFixed &&
        !this.isAnimating
    ) {
      requestAnimationFrame(this._promiseHeaderSlideOut.bind(this));
    }

    this.scrollTop = scrollTop;

    // The scroll event is fired randomly and is not guaranteed to fire when
    // scrollTop === 0. Double check after a short period to see if we need to
    // reset the header.
    this._doubleCheckPosition();
  }

  _doubleCheckPosition() {
    if (typeof this.doubleCheckDebounced === 'undefined') {
      this.doubleCheckDebounced = debounce(
          function() {
            this.scrollTop = $(document).scrollTop();
            if (this.scrollTop <= 0) {
              this._promiseHeaderReset();
            }
          }.bind(this),
          500
      );
    }

    this.doubleCheckDebounced();
  }

  _promiseHeaderReset() {
    this.promiseChain = this.promiseChain.then(
        function() {
          this.$container.removeClass(classes$16.headerFixed);
          $('body').css('padding-top', '');
          $('body').removeClass('headerFixed');
        }.bind(this)
    );
  }

  _promiseHeaderSlideIn() {
    this.isFixed = true;
    this.headerAnimating = true;
    this.$siteHeaderWrapper.css('transform', 'translateY(-100%)');

    requestAnimationFrame(
        function() {
          this.$container.addClass(classes$16.headerFixed);
          $('body').addClass('headerFixed');

          if (!this.$container.hasClass(classes$16.headerHomepage)) {
            $('body').css('padding-top', this.headerHeight);
          }

          requestAnimationFrame(
              function() {
                this.$siteHeaderWrapper.css({
                  transform: 'translateY(0%)',
                  transition: 'transform 0.25s ease-out'
                });
              }.bind(this)
          );
        }.bind(this)
    );

    return this.promiseTransitionEnd(this.$siteHeaderWrapper).then(
        function() {
          this.headerAnimating = false;
          this.$siteHeaderWrapper.attr('style', '');
          this.scrollTop = $(document).scrollTop();
          if (this.scrollTop <= 0) {
            this._promiseHeaderReset();
          }
        }.bind(this)
    );
  }

  _promiseHeaderSlideOut() {
    this.isFixed = false;
    this.headerAnimating = true;

    this.$siteHeaderWrapper.css({
      transform: 'translateY(-100%)',
      transition: 'transform 0.25s ease-out'
    });

    return this.promiseTransitionEnd(this.$siteHeaderWrapper).then(
        function() {
          this.headerAnimating = false;
          this.$siteHeaderWrapper.attr('style', '');
          $('body').css('padding-top', '');
          this.$container.removeClass(classes$16.headerFixed);
          $('body').removeClass('headerFixed');
        }.bind(this)
    );
  }



  /*--------------------------------------------------------------------------*/
  /*                              Navigation                                  */
  /*--------------------------------------------------------------------------*/
  showNavigation() {
    var isOpen = $(document.body).hasClass(classes$16.navigationOpen);
    this.siteNavigation = this.container.querySelector(
        selectors$17.siteNavigation
    );
    var navigationButton = this.siteNavigation.querySelector(
        selectors$17.navigationButton
    );

    if (!isOpen) {
      this.scrollHandler = false;

      this._adjustNavigationPadding();
      // a11y.trapFocus(this.siteNavigation, {
      //   elementToFocus: navigationButton
      // });

      this.enableTabbingOfChildren(selectors$17.navigation);
      $(selectors$17.navigation).attr('aria-hidden', false);

      $('body').css('overflow', 'hidden');

      this.promiseChain = this.promiseChain
          .then(this._promiseNavTransition.bind(this, true))
          .then(
              this._promiseNavItemsTransition.bind(
                  this,
                  $(selectors$17.navAnimateElements, this.$container).toArray(),
                  true
              )
          )
          .then(
              function() {
                $(document).on(
                    'keyup' + this.namespace,
                    this._closeOnEscape.bind(this)
                );
                $(selectors$17.navigationButton)
                    .attr('aria-expanded', true)
                    .off()
                    .one('click', this._toggleNavigationDisplay.bind(this));
              }.bind(this)
          );
    }

    return this.promiseChain.then(function() {
      // This class is only applied in the Theme Editor and makes sure that
      // the navigation links show when the section reloads from settings
      // changes.
      if (Shopify.designMode) {
        $(document.body).addClass(classes$16.navigationOpenEditor);
      }
    });
  }

  hideNavigation() {
    var isOpen = $(document.body).hasClass(classes$16.navigationOpen);

    if (isOpen) {
      var $navElements = $(selectors$17.navAnimateElements, this.$container);

      // a11y.removeTrapFocus();

      this.disableTabbingOfChildren(selectors$17.navigation);
      $(selectors$17.navigation).attr('aria-hidden', true);

      if (Shopify.designMode) {
        $(document.body).removeClass(classes$16.navigationOpenEditor);
        $navElements.addClass(classes$16.navigationEntranceActive);
      }

      $('body').css('overflow', 'auto');

      this.promiseChain = this.promiseChain
          .then(
              this._promiseNavItemsTransition.bind(
                  this,
                  $navElements.toArray().reverse(),
                  false
              )
          )
          .then(this._promiseNavTransition.bind(this, false))
          .then(
              function() {
                this.scrollHandler = true;
                $(document).off('keyup' + this.namespace);
                $(selectors$17.navigationButton)
                    .off()
                    .one('click', this._toggleNavigationDisplay.bind(this))
                    .attr('aria-expanded', false)
                    .focus();
              }.bind(this)
          );
    }

    return this.promiseChain;
  }

  _toggleNavigationDisplay() {
    this.navigationManuallyToggled = true;

    if ($(document.body).hasClass(classes$16.navigationOpen)) {
      this.hideNavigation();
    } else {
      this.showNavigation();
    }
  }

  _adjustNavigationPadding() {
    this.announcementHeight = $('.announcement-bar').height();
    this.headerHeight = this.$container.find('.site-header-sections').height();
    let announcementHeight = this.$siteHeader.find('.announcement-bar--visible').height();
    $(selectors$17.navigation, this.$container).css({
      top: this.headerHeight + 'px',
      'min-height': 'calc(100vh - ' + (this.headerHeight + announcementHeight) + 'px)',
      'max-height': 'calc(100vh - ' + (this.headerHeight + announcementHeight) + 'px)',
      height: 'calc(100dvh - '+(this.headerHeight+announcementHeight)+'px)'
    });
  }

  _promiseNavTransition(active) {
    $(document.body)
        .addClass(classes$16.navigationTransitioning)
        .toggleClass(classes$16.navigationOpen, active);

    $(window).scrollTop(this.scrollTop);

    return this
        .promiseTransitionEnd($(selectors$17.navigation, this.$container))
        .then(function() {
          $(document.body).removeClass(classes$16.navigationTransitioning);
        });
  }

  _promiseNavItemsTransition(elements, active) {
    return this.mapPromiseSeries(elements, function(index, element) {
      var $element = $(element);

      $element.toggleClass(classes$16.navigationEntranceActive, active);

      return this.promiseTransitionEnd($element);
    });
  }

  _closeOnEscape(evt) {
    if (evt.keyCode === 27) {
      this.hideNavigation();
    }
  }

  _toggleNavigationSublinks(evt) {
    var $anchor = $(evt.currentTarget);
    var $parent = $anchor.parent();
    var isExpanded = $anchor.attr('aria-expanded') === 'true';
    var $childSublinks = $parent.find(selectors$17.navigationExpandChildSublinks);

    $parent.toggleClass(classes$16.navigationHasSublinksCollapsed);
    $parent
        .siblings(selectors$17.navigationHasSublinks)
        .addClass(classes$16.navigationHasSublinksCollapsed)
        .children(selectors$17.navigationExpandSublinks)
        .attr('aria-expanded', false);

    this._setMaxHeight($parent.siblings(selectors$17.navigationHasSublinks), '');

    if ($childSublinks.length) {
      this._updateSublinkMaxHeight($anchor);
    }

    $anchor.attr('aria-expanded', !isExpanded);
    this._toggleSubNavigationElementHeight($anchor);
  }

  _updateSublinkMaxHeight($anchor) {
    var isChildSublink = $anchor.hasClass(
        classes$16.navigationExpandChildSublinks
    );

    if (!isChildSublink) {
      return;
    }

    var $sublinkContainer = $anchor.closest(
        selectors$17.navigationSublinksContainer
    );
    var $childSublinks = $sublinkContainer.find(
        selectors$17.navigationHasSublinks
    );

    var maxHeight = $sublinkContainer.data('max-height');

    $childSublinks.each(function() {
      var $el = $(this);

      if ($el.hasClass(classes$16.navigationHasSublinksCollapsed)) {
        return;
      }

      var $childSublink = $el.find(selectors$17.navigationChildSublinks);
      var $parent = $childSublink.parent();

      maxHeight += $parent.data('max-height');
    });

    $sublinkContainer.css('max-height', maxHeight);
  }

  _setSublinksMaxHeight() {
    $(selectors$17.navigationSublinks, this.$container).each(function() {
      var $el = $(this);
      var $parent = $el.parent();
      var sublinkHeight = $el.outerHeight();

      $parent
          .data('max-height', sublinkHeight)
          .css('max-height', sublinkHeight);
    });
  }

  _toggleSubNavigationElementHeight($anchor) {
    var $currentListItem = $anchor.parent('li');
    if ($currentListItem.hasClass(classes$16.navigationHasSublinksCollapsed)) {
      this._setMaxHeight($currentListItem, '');
    } else {
      if ($currentListItem.hasClass(selectors$17.navigationSublink)) {
        this._updateSublinkMaxHeight($currentListItem);
        return;
      }
      this._setMaxHeight($currentListItem, 'none');
    }
  }

  _setMaxHeight(element, maxHeight) {
    element.css('max-height', maxHeight);
  }


  enableTabbingOfChildren(containers) {
    $(containers).each(function(index, container) {
      $(
          'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]',
          container
      ).removeAttr('tabindex');
    });
  }

  promiseTransitionEnd($el) {
    var events =
        'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend';
    var properties = [
      'transition-duration',
      '-moz-transition-duration',
      '-webkit-transition-duration',
      '-o-transition-duration'
    ];
    var duration = 0;
    var promise = $.Deferred().resolve();

    // check the various CSS properties to see if a duration has been set
    $.each(properties, function(index, value) {
      duration || (duration = parseFloat($el.css(value))); // eslint-disable-line no-unused-expressions
    });
    if (duration > 0) {
      promise = $.Deferred(function(defer) {
        $el.on(events, function(evt) {
          if (evt.target !== $el[0]) return;
          $el.off(events);
          defer.resolve();
        });
      });
    }

    return promise;
  }
  mapPromiseSeries(iterable, cb, delay) {
    var series = $.Deferred().resolve();

    $.each(iterable, function(index, item) {
      series = series.then(function() {
        if (typeof delay === 'number') {
          return delayedReturn(index, item);
        } else {
          return cb(index, item);
        }
      });
    });

    function delayedReturn(index, item) {
      return $.Deferred(function(defer) {
        setTimeout(function() {
          defer.resolve(cb(index, item)); // eslint-disable-line callback-return
        }, delay);
      });
    }

    return series;
  }


  utils = {
    pointerEventToXY: function(event) {
      var position;

      if (event.originalEvent.touches) {
        position =
            event.originalEvent.touches[0] || event.originalEvent.changedTouches[0];
      } else {
        position = event;
      }
      return {
        x: position.pageX,
        y: position.pageY
      };
    },

    promiseRepeatSeries: function(promise, count) {
      count--;

      return promise().then(
          function() {
            // eslint-disable-line consistent-return
            if (count) {
              return this.promiseRepeatSeries(promise, count);
            }
          }.bind(this)
      );
    },

    mapPromiseSeries: function(iterable, cb, delay) {
      var series = $.Deferred().resolve();

      $.each(iterable, function(index, item) {
        series = series.then(function() {
          if (typeof delay === 'number') {
            return delayedReturn(index, item);
          } else {
            return cb(index, item);
          }
        });
      });

      function delayedReturn(index, item) {
        return $.Deferred(function(defer) {
          setTimeout(function() {
            defer.resolve(cb(index, item)); // eslint-disable-line callback-return
          }, delay);
        });
      }

      return series;
    },

    promiseAnimationEnd: function($el) {
      var events = 'animationend webkitAnimationEnd oAnimationEnd';
      var properties = [
        'animation-duration',
        '-moz-animation-duration',
        '-webkit-animation-duration',
        '-o-animation-duration'
      ];
      var duration = 0;
      var promise = $.Deferred().resolve();

      // check the various CSS properties to see if a duration has been set
      $.each(properties, function(index, value) {
        duration || (duration = parseFloat($el.css(value))); // eslint-disable-line no-unused-expressions
      });

      if (duration > 0) {
        promise = $.Deferred(function(defer) {
          $el.on(events, function(evt) {
            if (evt.target !== $el[0]) return;
            $el.off(events);
            defer.resolve();
          });
        });
      }

      return promise;
    },

    promiseTransitionEnd: function($el) {
      var events =
          'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend';
      var properties = [
        'transition-duration',
        '-moz-transition-duration',
        '-webkit-transition-duration',
        '-o-transition-duration'
      ];
      var duration = 0;
      var promise = $.Deferred().resolve();

      // check the various CSS properties to see if a duration has been set
      $.each(properties, function(index, value) {
        duration || (duration = parseFloat($el.css(value))); // eslint-disable-line no-unused-expressions
      });

      if (duration > 0) {
        promise = $.Deferred(function(defer) {
          $el.on(events, function(evt) {
            if (evt.target !== $el[0]) return;
            $el.off(events);
            defer.resolve();
          });
        });
      }

      return promise;
    },

    isLocalStorageSupported: function() {
      var mod = 'localStorageTest';
      try {
        localStorage.setItem(mod, mod);
        localStorage.removeItem(mod);
        return true;
      } catch (error) {
        return false;
      }
    },

    isSessionStorageSupported: function() {
      var mod = 'sessionStorageTest';
      try {
        sessionStorage.setItem(mod, mod);
        sessionStorage.removeItem(mod);
        return true;
      } catch (error) {
        return false;
      }
    },

    /**
     * Set all tabbable elements tabindex attribute to '-1' so that they are not
     * tabbable. Great for if you want to hide something with opacity: 0 or
     * visibility: hidden, but don't want interactivity
     *
     * @param {any} container - Container to look for children elements to disable
     */
    disableTabbingOfChildren: function(containers) {
      $(containers).each(function(index, container) {
        $(
            'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]',
            container
        ).attr('tabindex', '-1');
      });
    },

    /**
     * Remove all tabbable elements' tabindex attribute so that they assume their
     * normal tabbing behaviour.
     *
     * @param {any} container - Container to look for children elements to reset
     */
    enableTabbingOfChildren: function(containers) {
      $(containers).each(function(index, container) {
        $(
            'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]',
            container
        ).removeAttr('tabindex');
      });
    },

    isiOSSafari: function() {
      var userAgent = window.navigator.userAgent;
      var iOS =
          Boolean(userAgent.match(/iPad/i)) || Boolean(userAgent.match(/iPhone/i));
      var webkit = Boolean(userAgent.match(/WebKit/i));

      return iOS && webkit && !userAgent.match(/CriOS/i);
    },

    disableScrollBody: function() {
      // If the body isn't tall enough to scroll then we have nothing to disable
      if (document.body.scrollHeight - window.innerHeight === 0) return;

      $('html').addClass(classes$1.disableScroll);
    },

    enableScrollBody: function() {
      $('html').removeClass(classes$1.disableScroll);
    },

    updateUrlParameter: function(url, key, value) {
      var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
      var separator = url.indexOf('?') === -1 ? '?' : '&';

      if (url.match(re)) {
        return url.replace(re, '$1' + key + '=' + value + '$2');
      } else {
        return url + separator + key + '=' + value;
      }
    },

    cookiesEnabled: function() {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled) {
        document.cookie = 'testcookie';
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
      }
      return cookieEnabled;
    },

    onFirst: function(name, fn) {
      // bind as you normally would
      // don't want to miss out on any jQuery magic
      this.on(name, fn);

      this.each(function() {
        var handlers = $._data(this, 'events')[name.split('.')[0]];
        // take out the handler we just inserted from the end
        var handler = handlers.pop();
        // move it at the beginning
        handlers.splice(0, 0, handler);
      });
    },

    // Returns a promise that is only resolved when the main stylesheet has been
    // downloaded.
    promiseStylesheet: function() {
      if (typeof this.stylesheetPromise === 'undefined') {
        this.stylesheetPromise = $.Deferred(function(defer) {
          var link = document.querySelector(
              'link[href="' + theme.stylesheet + '"]'
          );

          if (link.loaded) {
            defer.resolve();
          }

          /* eslint-disable no-undef */
          onloadCSS(link, function() {
            // Global onloadCSS function injected by load-css.liquid
            defer.resolve();
          });
        });
      }

      return this.stylesheetPromise;
    },

    isMobile: function() {
      // Create a scoped variable that stores the current status
      var status = false;

      // Replace utils.isMobile function with a function that returns the status.
      // This makes sure the code below is on executed once, and then from there
      // on the only thing that isMobile does is return var status.
      this.isMobile = function() {
        return status;
      };

      function checkIfMobile() {
        status = $(window).outerWidth() < theme.mediaQuerySmall;
        return status;
      }

      // Make sure that this resize handler is the first handler in the event loop
      $.fn.onFirst = this.onFirst;

      // This event handler is only assigned once.
      $(window).onFirst('resize', checkIfMobile);

      // Set the initial value of status and return that value. After this,
      // isMobile() will return `var status`
      return checkIfMobile();
    },

    isTablet: function() {
      // Create a scoped variable that stores the current status
      var status = false;

      // Replace utils.isTablet function with a function that returns the status.
      // This makes sure the code below is on executed once, and then from there
      // on the only thing that isTablet does is return var status.
      this.isTablet = function() {
        return status;
      };

      function checkIfTablet() {
        var width = $(window).outerWidth();
        status = width > theme.mediaQuerySmall && width < theme.mediaQueryMedium;
        return status;
      }

      // Make sure that this resize handler is the first handler in the event loop
      $.fn.onFirst = this.onFirst;

      // This event handler is only assigned once.
      $(window).onFirst('resize', checkIfTablet);

      // Set the initial value of status and return that value. After this,
      // isTablet() will return `var status`
      return checkIfTablet();
    },

    isInOrAboveViewport: function(element) {
      var rect = element.getBoundingClientRect();
      var offset = 50;

      return (
          // The top is in view: the top is more than 0 and less than the window height (the top of the element is in view)
          (rect.top + offset >= 0 && rect.top + offset <= window.innerHeight) ||
          // The bottom is in view: bottom position is greater than 0 and greater than the window height
          (rect.bottom + offset >= 0 &&
              rect.bottom + offset <= window.innerHeight) ||
          // The top is above the viewport and the bottom is below the viewport
          (rect.top + offset < 0 && rect.bottom + offset > window.innerHeight) ||
          // The bottom is above the viewport
          rect.bottom < 0
      );
    },

    keyboardKeys: {
      TAB: 9,
      ENTER: 13,
      SPACE: 32,
      LEFTARROW: 37,
      RIGHTARROW: 39
    }
  };
}

customElements.define('header-section', HeaderSection);
